<template>
  <div>
    <a-row class="row">
      <a-col :span="24">
        <div class="row-css">
          <div class="row-samp"></div>
          水质状态
        </div>
      </a-col>
    </a-row>
    <div class="main">
      <div style="margin-left: 20px; margin-top: 10px;">泵房总数：{{ datsum }} 个</div>
      <a-row :gutter="12">
        <a-col :span="8">
          <oringconf key="date2" :data="ProportionUserList"></oringconf>
        </a-col>
        <a-col :span="8">
          <oringconf key="date2" :data="Turbidity"></oringconf>
        </a-col>
        <a-col :span="8">
          <oringconf key="date2" :data="Residualchlorine"></oringconf>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import { getUUID } from '../../../utils/util'
import AvatarDropdown from '@/components/GlobalHeader/AvatarDropdown.vue'
import oringconf from './oring-conf.vue'
import { rgb } from 'webpack-theme-color-replacer/client/varyColor'
export default {
  components: { AvatarDropdown, oringconf },
  data () {
    return {
      id: getUUID(),
      ProportionUserList: [],
      Turbidity: [],
      Residualchlorine: [],
      datsum: ''
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    getList () {
      // 远传水表占比
      this.$http.get('/pipe-network/twice_water/statistics/twice').then((res) => {
        const datay = res.data[0]
        const datas = res.data[2]
        const datad = res.data[1]
        this.datsum = datas.sum
        const lists = {
          PieChart: [
            { value: datas.normalNum, name: '正常数' },
            { value: datas.indeterminacyNum, name: '不正常' },
            { value: datas.uninstalled, name: '未安装' }
          ],
          title: datas.typeName,
          color: ['rgb(26,134,215)', 'rgb(91,171,234)', 'rgb(145,205,248)']
        }
        const listst = {
          PieChart: [
            { value: datay.normalNum, name: '正常数' },
            { value: datay.indeterminacyNum, name: '不正常' },
            { value: datay.uninstalled, name: '未安装' }
          ],
          title: datay.typeName,
          color: ['rgb(0,189,152)', 'rgb(42,212,188)', 'rgb(152,235,224)']
        }
        const listsd = {
          PieChart: [
            { value: datad.normalNum, name: '正常数' },
            { value: datad.indeterminacyNum, name: '不正常' },
            { value: datad.uninstalled, name: '未安装' }
          ],
          title: datad.typeName,
          color: ['rgb(128,88,239)', 'rgb(159,124,255)', 'rgb(176,150,247)']
        }
        this.ProportionUserList = lists
        this.Turbidity = listst
        this.Residualchlorine = listsd
      })
    }
  }
}
</script>

<style lang='less' scoped>
.row {
  margin-top: 16px;
  height: 53px;
  border-bottom: 1px #f1f2f4 solid;
}

.row-css {
  display: flex;
  align-items: center;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}

.row-samp {
  width: 4px;
  height: 18px;
  margin-right: 10px;
  margin-left: 10px;
  background: #0265ff;
  border-radius: 3px;
}

.col-gutter {
  width: 94.06px;
  height: 75.51px;
  margin-left: 29px;
  margin-top: 20px;
  background-image: linear-gradient(90deg, #fafcff 0%, #f2f6ff 100%);
  border-radius: 4px;
}

.col-gutter:nth-child(2) {
  margin-right: 99.94px;
  margin-left: 99px;
}

.nav {
  display: flex;
  align-items: center;
}

.main {
  width: 100%;
  height: 219px;
}
</style>
